<template>
  <div id="DicItem" class="h-full">
    <el-card class="h-full" :body-style="{ padding: '20px', height: '100%' }">
      <el-row :gutter="10" type="flex" justify="space-between">
        <el-col :span="24" class="flex h-36px">
          <el-form :model="queryForm" class="flex mr-10px">
            <el-form-item class="mr-10px">
              <el-input size="small" v-model="queryForm.code" :placeholder="$t('code')" clearable />
            </el-form-item>
            <el-form-item>
              <el-input size="small" v-model="queryForm.name" :placeholder="$t('name')" clearable />
            </el-form-item>
          </el-form>
          <el-button type="primary" @click="searchTableData()">{{ $t('search') }}</el-button>
          <el-button
            type="primary"
            :disabled="!$hasAccess('create')"
            @click="handleEvent('create')"
            >{{ $t('create') }}</el-button
          >
        </el-col>
      </el-row>
      <el-table
        border
        stripe
        :data="tableData"
        v-loading="tableLoading"
        :highlight-current-row="true"
        height="calc(100% - 106px)"
        style="width: 100%; overflow-y: auto"
        @selection-change="handleSelectionChange"
        ref="multipleTable"
        class="mt-20px"
      >
        <el-table-column type="index" width="65" :label="$t('seqNo')">
          <template slot-scope="scope">
            <span>{{ (page.pageNo - 1) * page.pageSize + scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('typeName')"
          prop="dicCateId"
          show-overflow-tooltip
          v-if="environment === 'SAAS'"
        ></el-table-column>
        <el-table-column :label="$t('code')" prop="code" show-overflow-tooltip></el-table-column>
        <el-table-column
          :label="$t('name')"
          prop="displayName"
          show-overflow-tooltip
          v-if="environment === 'DIY'"
        ></el-table-column>
        <el-table-column
          :label="$t('name')"
          prop="name"
          show-overflow-tooltip
          v-if="environment === 'SAAS'"
        ></el-table-column>
        <el-table-column
          :label="$t('value')"
          prop="data"
          show-overflow-tooltip
          v-if="environment === 'DIY'"
        ></el-table-column>
        <el-table-column
          :label="$t('value')"
          prop="value"
          show-overflow-tooltip
          v-if="environment === 'SAAS'"
        ></el-table-column>
        <el-table-column
          :label="$t('description')"
          prop="remark"
          show-overflow-tooltip
          v-if="environment === 'DIY'"
        ></el-table-column>
        <el-table-column
          :label="$t('description')"
          prop="description"
          show-overflow-tooltip
          v-if="environment === 'SAAS'"
        ></el-table-column>
        <!-- <el-table-column
          v-for="item in tableHeader"
          :label="item.comment"
          :key="item.title"
          :width="item.width"
          show-overflow-tooltip
          :prop="item.bindDataName"
        >
          <template slot-scope="scope">
            <span v-if="item.controlType === 4">
              {{
                computedSelectValue(
                  _.find(listTypes, ['bindDataName', item.bindDataName]),
                  scope.row[item.bindDataName]
                )
              }}
            </span>
            <span v-else>{{ scope.row[item.bindDataName] }}</span>
          </template>
        </el-table-column> -->
        <el-table-column :label="$t('operate')" width="200" fixed="right">
          <template slot-scope="scope">
            <el-button
              :disabled="!$hasAccess('read')"
              size="mini"
              @click="handleEvent('read', scope.row)"
              >{{ $t('view') }}</el-button
            >
            <el-button
              :disabled="!$hasAccess('update')"
              size="mini"
              @click="handleEvent('edit', scope.row)"
              >{{ $t('edit') }}</el-button
            >
            <el-button
              :disabled="!$hasAccess('delete')"
              size="mini"
              @click="handleEvent('delete', scope.row)"
              >{{ $t('delete') }}</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="mt-20px float-right"
        background
        @size-change="searchTableData()"
        @current-change="findTableData()"
        :current-page.sync="page.pageNo"
        :page-sizes="$pageSizeAll"
        :page-size.sync="page.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="page.recordCount"
      ></el-pagination>
      <!-- 新增、编辑、修改start -->
      <el-dialog
        :title="dialogTitle"
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        class="mini-dialog"
        v-dialogDrag
      >
        <el-form label-width="150px" :model="form" :rules="rules" label-position="right" ref="form">
          <el-form-item :label="$t('typeName')" prop="dataCategoryId" v-if="environment === 'SAAS'">
            <el-select size="small" v-model="form.dataCategoryId" :disabled="handleType === 'read'">
              <el-option
                v-for="(item, index) in dicCateIdList"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('code')" prop="code">
            <el-input size="small" v-model="form.code" :disabled="handleType === 'read'"></el-input>
          </el-form-item>
          <el-form-item :label="$t('name')" prop="displayName" v-if="environment === 'DIY'">
            <el-input
              size="small"
              v-model="form.displayName"
              :disabled="handleType === 'read'"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('name')" prop="name" v-if="environment === 'SAAS'">
            <el-input size="small" v-model="form.name" :disabled="handleType === 'read'"></el-input>
          </el-form-item>
          <el-form-item :label="$t('value')" prop="data" v-if="environment === 'DIY'">
            <el-input size="small" v-model="form.data" :disabled="handleType === 'read'"></el-input>
          </el-form-item>
          <el-form-item :label="$t('value')" prop="value" v-if="environment === 'SAAS'">
            <el-input
              size="small"
              v-model="form.value"
              :disabled="handleType === 'read'"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('description')" v-if="environment === 'DIY'">
            <el-input
              size="small"
              v-model="form.remark"
              :disabled="handleType === 'read'"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('description')" v-if="environment === 'SAAS'">
            <el-input
              size="small"
              v-model="form.description"
              :disabled="handleType === 'read'"
            ></el-input>
          </el-form-item>
        </el-form>
        <div class="text-center" slot="footer" v-if="_.includes(['create', 'edit'], handleType)">
          <el-button type="primary" size="small" @click="saveEdit" :loading="saveLoading">
            {{ $t('save') }}
          </el-button>
          <el-button size="small" @click="dialogVisible = false"> {{ $t('cancel') }} </el-button>
        </div>
        <!-- <table-com
          v-if="dialogVisible"
          ref="tableCom"
          :colsPerRow="2"
          :labelWidth="'100px'"
          :disabledArr="['dicCateId']"
          :formData="formData"
          :handleId="handleId"
          :formRules="formRules"
          :formEnRules="formEnRules"
          :handleType="handleType"
          @saveProfession="saveEdit"
          @cancelSaveSite="dialogVisible = false"
        ></table-com> -->
      </el-dialog>
      <!-- 新增、编辑、修改end -->
      <!-- 上传excel start -->
      <upload-excel ref="excel" excelType="DicItem" @refreshList="searchTableData"></upload-excel>
      <!-- 上传excel end -->
    </el-card>
  </div>
</template>
<script>
import CommonService from '@/services/CommonStd'
// import tableCom from '@/components/form'
import uploadExcel from '@/components/upload'

export default {
  name: 'DicItem',
  components: {
    // tableCom,
    uploadExcel,
  },
  mixins: [],
  data() {
    return {
      tableLoading: false,
      queryForm: {}, // 查询字段
      queryData: [], // 查询字段的数组
      initTypes: ['int', 'float', 'double', 'bit', 'decimal', 'numeric', 'tinyint'],
      keywords: '',
      formData: [], // 表单数据
      handleData: {},
      dialogTitle: '新增',
      dialogVisible: false,
      handleType: 'create',
      handleId: '',
      page: {
        pageNo: 1,
        pageSize: 15,
        recordCount: 0,
      },
      tableHeader: [
        // {
        //   alias: '',
        //   bindDataName: 'code',
        //   comment: '代码',
        //   controlLength: 0,
        //   controlType: 0,
        //   dataSourceUrl: '',
        //   dataType: 'varchar',
        //   formShow: 1,
        //   listShow: 1,
        //   name: 'code',
        //   queryShow: 0,
        //   readOnly: 0,
        //   required: 0,
        //   seqNo: 2,
        //   sourceColumn: '',
        //   sourcePrimarykey: 'id',
        //   sourceTable: '',
        //   table: 'dic_item',
        //   title: this.$t('code'),
        //   value: '',
        // },
        // {
        //   alias: '',
        //   bindDataName: 'displayName',
        //   comment: '名称',
        //   controlLength: 0,
        //   controlType: 0,
        //   dataSourceUrl: '',
        //   dataType: 'varchar',
        //   formShow: 1,
        //   listShow: 1,
        //   name: 'name',
        //   queryShow: 0,
        //   readOnly: 0,
        //   required: 0,
        //   seqNo: 10,
        //   sourceColumn: '',
        //   sourcePrimarykey: 'id',
        //   sourceTable: '',
        //   table: 'dic_item',
        //   title: this.$t('name'),
        //   value: '',
        // },
        // {
        //   alias: '',
        //   bindDataName: 'data',
        //   comment: '字典值',
        //   controlLength: 0,
        //   controlType: 0,
        //   dataSourceUrl: '',
        //   dataType: 'varchar',
        //   formShow: 1,
        //   listShow: 1,
        //   name: 'Value',
        //   queryShow: 0,
        //   readOnly: 0,
        //   required: 0,
        //   seqNo: 14,
        //   sourceColumn: '',
        //   sourcePrimarykey: 'id',
        //   sourceTable: '',
        //   table: 'dic_item',
        //   title: this.$t('value'),
        //   value: '',
        // },
        // {
        //   alias: '',
        //   bindDataName: 'remark',
        //   comment: '备注',
        //   controlLength: 0,
        //   controlType: 0,
        //   dataSourceUrl: '',
        //   dataType: 'varchar',
        //   formShow: 1,
        //   listShow: 1,
        //   name: 'description',
        //   queryShow: 0,
        //   readOnly: 0,
        //   required: 0,
        //   seqNo: 5,
        //   sourceColumn: '',
        //   sourcePrimarykey: 'id',
        //   sourceTable: '',
        //   table: 'dic_item',
        //   title: '备注',
        //   value: '',
        // },
      ],
      tableData: [],
      formRules: {},
      formEnRules: {},
      listTypes: [
        // {
        //   alias: '',
        //   bindDataName: 'dicCateId',
        //   comment: '类型名称',
        //   controlLength: 0,
        //   controlType: 0,
        //   dataSourceUrl: '',
        //   dataType: 'varchar',
        //   formShow: 1,
        //   listShow: 1,
        //   name: 'dicCateId',
        //   queryShow: 0,
        //   readOnly: 0,
        //   required: 1,
        //   seqNo: 2,
        //   sourceColumn: '',
        //   sourcePrimarykey: 'id',
        //   sourceTable: '',
        //   table: 'dic_item',
        //   title: this.$t('typeName'),
        //   value: '',
        // },
        // {
        //   alias: '',
        //   bindDataName: 'code',
        //   comment: '代码',
        //   controlLength: 0,
        //   controlType: 0,
        //   dataSourceUrl: '',
        //   dataType: 'varchar',
        //   formShow: 1,
        //   listShow: 1,
        //   name: 'code',
        //   queryShow: 0,
        //   readOnly: 0,
        //   required: 0,
        //   seqNo: 2,
        //   sourceColumn: '',
        //   sourcePrimarykey: 'id',
        //   sourceTable: '',
        //   table: 'dic_item',
        //   title: this.$t('code'),
        //   value: '',
        // },
        // {
        //   alias: '',
        //   bindDataName: 'name',
        //   comment: '名称',
        //   controlLength: 0,
        //   controlType: 0,
        //   dataSourceUrl: '',
        //   dataType: 'varchar',
        //   formShow: 1,
        //   listShow: 1,
        //   name: 'name',
        //   queryShow: 0,
        //   readOnly: 0,
        //   required: 1,
        //   seqNo: 10,
        //   sourceColumn: '',
        //   sourcePrimarykey: 'id',
        //   sourceTable: '',
        //   table: 'dic_item',
        //   title: this.$t('name'),
        //   value: '',
        // },
        // {
        //   alias: '',
        //   bindDataName: 'value',
        //   comment: '字典值',
        //   controlLength: 0,
        //   controlType: 0,
        //   dataSourceUrl: '',
        //   dataType: 'varchar',
        //   formShow: 1,
        //   listShow: 1,
        //   name: 'Value',
        //   queryShow: 0,
        //   readOnly: 0,
        //   required: 0,
        //   seqNo: 14,
        //   sourceColumn: '',
        //   sourcePrimarykey: 'id',
        //   sourceTable: '',
        //   table: 'dic_item',
        //   title: this.$t('value'),
        //   value: '',
        // },
        // {
        //   alias: '',
        //   bindDataName: 'description',
        //   comment: '备注',
        //   controlLength: 0,
        //   controlType: 0,
        //   dataSourceUrl: '',
        //   dataType: 'varchar',
        //   formShow: 1,
        //   listShow: 1,
        //   name: 'description',
        //   queryShow: 0,
        //   readOnly: 0,
        //   required: 0,
        //   seqNo: 5,
        //   sourceColumn: '',
        //   sourcePrimarykey: 'id',
        //   sourceTable: '',
        //   table: 'dic_item',
        //   title: '备注',
        //   value: '',
        // },
      ],
      dicTypeId: '',
      form: {
        dataCategoryId: '',
        code: '',
        displayName: '',
        data: '',
        remark: '',
        name: '',
        value: '',
        description: '',
      },
      rules: {
        // dataCategoryId: [
        //   { required: true, message: this.$t('PleaseSelectLeibieName'), trigger: 'blur' },
        // ],
        // code: [{ required: true, message: this.$t('pleaseEnterCode'), trigger: 'blur' }],
        // displayName: [{ required: true, message: this.$t('PleaseEnterAName'), trigger: 'blur' }],
        // name: [{ required: true, message: this.$t('PleaseEnterAName'), trigger: 'blur' }],
        // data: [{ required: true, message: this.$t('enterTheDictionaryValue'), trigger: 'blur' }],
        // value: [{ required: true, message: this.$t('enterTheDictionaryValue'), trigger: 'blur' }],
      },
      dicCateIdList: [],
      saveLoading: false,
    }
  },
  computed: {
    environment() {
      return Wiz.GetModuleConfig('legacy-resource').currentEnv.environment
    },
    currentService() {
      return this.environment === 'DIY' ? 'std/DataItem' : 'std/DicItem'
    },
  },
  async created() {
    // this.$t 在 data 中未存在
    ;(this.tableHeader = [
      {
        alias: '',
        bindDataName: 'code',
        comment: '代码',
        controlLength: 0,
        controlType: 0,
        dataSourceUrl: '',
        dataType: 'varchar',
        formShow: 1,
        listShow: 1,
        name: 'code',
        queryShow: 0,
        readOnly: 0,
        required: 0,
        seqNo: 2,
        sourceColumn: '',
        sourcePrimarykey: 'id',
        sourceTable: '',
        table: 'dic_item',
        title: this.$t('code'),
        value: '',
      },
      {
        alias: '',
        bindDataName: 'displayName',
        comment: '名称',
        controlLength: 0,
        controlType: 0,
        dataSourceUrl: '',
        dataType: 'varchar',
        formShow: 1,
        listShow: 1,
        name: 'name',
        queryShow: 0,
        readOnly: 0,
        required: 0,
        seqNo: 10,
        sourceColumn: '',
        sourcePrimarykey: 'id',
        sourceTable: '',
        table: 'dic_item',
        title: this.$t('name'),
        value: '',
      },
      {
        alias: '',
        bindDataName: 'data',
        comment: '字典值',
        controlLength: 0,
        controlType: 0,
        dataSourceUrl: '',
        dataType: 'varchar',
        formShow: 1,
        listShow: 1,
        name: 'Value',
        queryShow: 0,
        readOnly: 0,
        required: 0,
        seqNo: 14,
        sourceColumn: '',
        sourcePrimarykey: 'id',
        sourceTable: '',
        table: 'dic_item',
        title: this.$t('value'),
        value: '',
      },
      {
        alias: '',
        bindDataName: 'remark',
        comment: '备注',
        controlLength: 0,
        controlType: 0,
        dataSourceUrl: '',
        dataType: 'varchar',
        formShow: 1,
        listShow: 1,
        name: 'description',
        queryShow: 0,
        readOnly: 0,
        required: 0,
        seqNo: 5,
        sourceColumn: '',
        sourcePrimarykey: 'id',
        sourceTable: '',
        table: 'dic_item',
        title: '备注',
        value: '',
      },
    ]),
      (this.listTypes = [
        {
          alias: '',
          bindDataName: 'dicCateId',
          comment: '类型名称',
          controlLength: 0,
          controlType: 0,
          dataSourceUrl: '',
          dataType: 'varchar',
          formShow: 1,
          listShow: 1,
          name: 'dicCateId',
          queryShow: 0,
          readOnly: 0,
          required: 1,
          seqNo: 2,
          sourceColumn: '',
          sourcePrimarykey: 'id',
          sourceTable: '',
          table: 'dic_item',
          title: this.$t('typeName'),
          value: '',
        },
        {
          alias: '',
          bindDataName: 'code',
          comment: '代码',
          controlLength: 0,
          controlType: 0,
          dataSourceUrl: '',
          dataType: 'varchar',
          formShow: 1,
          listShow: 1,
          name: 'code',
          queryShow: 0,
          readOnly: 0,
          required: 0,
          seqNo: 2,
          sourceColumn: '',
          sourcePrimarykey: 'id',
          sourceTable: '',
          table: 'dic_item',
          title: this.$t('code'),
          value: '',
        },
        {
          alias: '',
          bindDataName: 'name',
          comment: '名称',
          controlLength: 0,
          controlType: 0,
          dataSourceUrl: '',
          dataType: 'varchar',
          formShow: 1,
          listShow: 1,
          name: 'name',
          queryShow: 0,
          readOnly: 0,
          required: 1,
          seqNo: 10,
          sourceColumn: '',
          sourcePrimarykey: 'id',
          sourceTable: '',
          table: 'dic_item',
          title: this.$t('name'),
          value: '',
        },
        {
          alias: '',
          bindDataName: 'value',
          comment: '字典值',
          controlLength: 0,
          controlType: 0,
          dataSourceUrl: '',
          dataType: 'varchar',
          formShow: 1,
          listShow: 1,
          name: 'Value',
          queryShow: 0,
          readOnly: 0,
          required: 0,
          seqNo: 14,
          sourceColumn: '',
          sourcePrimarykey: 'id',
          sourceTable: '',
          table: 'dic_item',
          title: this.$t('value'),
          value: '',
        },
        {
          alias: '',
          bindDataName: 'description',
          comment: '备注',
          controlLength: 0,
          controlType: 0,
          dataSourceUrl: '',
          dataType: 'varchar',
          formShow: 1,
          listShow: 1,
          name: 'description',
          queryShow: 0,
          readOnly: 0,
          required: 0,
          seqNo: 5,
          sourceColumn: '',
          sourcePrimarykey: 'id',
          sourceTable: '',
          table: 'dic_item',
          title: '备注',
          value: '',
        },
      ]),
      (this.rules = {
        dataCategoryId: [
          { required: true, message: this.$t('PleaseSelectLeibieName'), trigger: 'blur' },
        ],
        code: [{ required: true, message: this.$t('pleaseEnterCode'), trigger: 'blur' }],
        displayName: [{ required: true, message: this.$t('PleaseEnterAName'), trigger: 'blur' }],
        name: [{ required: true, message: this.$t('PleaseEnterAName'), trigger: 'blur' }],
        data: [{ required: true, message: this.$t('enterTheDictionaryValue'), trigger: 'blur' }],
        value: [{ required: true, message: this.$t('enterTheDictionaryValue'), trigger: 'blur' }],
      })
    // await this.findInitConfigData() // 获取tableHeader和listTypes
    // await this.findSourceData() // 获取下拉框数据
    // await this.setFormRules() // 设置表单规则校验
    // await this.filterQueryData() // 过滤查询字段
    // this.searchTableData()
  },
  methods: {
    async findInitConfigData() {
      const res = await CommonService.findCodeTemplate({
        route_name: 'DicItem',
      })
      if (res && res.code === 0 && res.data) {
        // 获取主表
        const mainTable = _.find(res.data[0].baseDto.tableList, ['isMain', 1])
        // 筛选过滤主表的tableHeadder
        this.tableHeader = _.filter(res.sourceData, (item) => {
          return item.table === mainTable.table
        })
        // 筛选过滤主表的listTypes
        this.listTypes = _.filter(res.data[0].baseDto.columnList, (item) => {
          item.bindDataName = _.camelCase(item.name)
          return item.table === mainTable.table
        })
      }
    },
    filterQueryData() {
      this.queryData = _.filter(this.listTypes, (item) => {
        if (item.queryShow) {
          this.$set(this.queryForm, item.bindDataName, '')
        }
        return item.queryShow
      })
    },
    setFormRules() {
      const inputTypes = [-1, 0, 1]
      _.forEach(this.listTypes, (item) => {
        if (item.formShow && item.required) {
          // 必填且是表单显示
          this.$set(this.formRules, item.bindDataName, [
            {
              required: true,
              message: `${
                _.includes(inputTypes, item.controlType)
                  ? this.$t('pleaseEnter')
                  : this.$t('pleaseSelect')
              }${item.title}`,
              tribugger: 'blur',
            },
          ])
          this.$set(this.formEnRules, item.bindDataName, [
            {
              required: true,
              message: `${
                _.includes(inputTypes, item.controlType) ? 'please enter the' : 'please select the'
              } ${item.bindDataName}`,
              tribugger: 'blur',
            },
          ])
        }
      })
    },
    findSourceData() {
      // 修改字典类型为下拉选择框显示
      this.listTypes[0].controlType = 4
      this.listTypes[0].formShow = 1
      this.listTypes[0].required = 1
      this.listTypes[0].dataSourceUrl = this.currentService
      _.forEach(this.listTypes, (item) => {
        if (item.controlType > 3 && item.dataSourceUrl) {
          this.findItemSourceData(item, item.dataSourceUrl)
        }
      })
    },
    async findItemSourceData(item, url) {
      const res = await CommonService.findSourceData(url)
      if (res && res.data) {
        item.sourceData = res.data
        item.selects = res.data
        if (item.bindDataName === 'dicCateId') {
          this.dicCateIdList = res.data
        }
      }
    },
    computedSelectValue(row, value) {
      if (row && row.selects && value) {
        const currentRow = _.find(row.selects, ['id', value])
        return currentRow ? currentRow.name : ''
      }
      return ''
    },
    handleSelectionChange(val) {
      _.forEach(this.totalSelection, (item) => {
        if (_.find(this.tableData, ['id', item.id])) {
          this.totalSelection = _.difference(this.totalSelection, [item])
        }
      })
      this.totalSelection = [...this.totalSelection, ...val]
    },
    importExperience() {
      this.$refs.excel.uploadExcelVisible = true
    },
    refreshList() {
      // 刷新列表
      this.page.pageNo = 1
      this.totalSelection = []
      this.searchTableData()
    },
    async exportFile() {
      const res = await CommonService.exportFile({
        reqUrl: this.currentService,
        reqData: {
          urlParam: '',
          ids: _.map(this.totalSelection, (item) => {
            return item.id
          }),
          downloadType: 0,
        },
      })
      if (res && res.url && res.code === 0) {
        if (_.includes(res.url, '://')) {
          window.location.href = res.url
        } else {
          window.location.href = `${currentEnv.VUE_APP_SERVER}${res.url}`
        }
      }
    },
    formatData(data) {
      // 格式化新增、编辑的数据
      const model = {}
      _.forIn(data, (value, key) => {
        const currentRow = _.find(this.listTypes, ['bindDataName', key])
        if (
          currentRow &&
          (_.includes(this.initTypes, currentRow.dataType) ||
            _.includes(this.bolTypes, currentRow.controlType))
        ) {
          model[key] = _.toNumber(value)
        } else {
          model[key] = value
        }
      })
      return model
    },
    async saveEdit() {
      // 修改、新增保存
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          if (this.form.id) {
            this.saveLoading = true
            let resData = null
            if (this.environment === 'DIY') {
              resData = await CommonService.updateDIY({
                reqUrl: `${this.currentService}/${this.form.id}`,
                reqData: this.form,
              })
            } else {
              resData = await CommonService.updateSAAS({
                reqUrl: this.currentService,
                reqData: { model: this.formatData(this.form) },
              })
            }
            this.saveLoading = false
            if (resData && resData.code === 0) {
              this.$message.success(resData.msg)
              this.findTableData()
              this.dialogVisible = false
            }
            return
          }
          this.saveLoading = true
          const res = await CommonService.create({
            reqUrl: this.currentService,
            reqData: this.environment === 'DIY' ? this.form : { model: this.formatData(this.form) },
          })
          this.saveLoading = false
          if (res && res.code === 0) {
            this.$message.success(res.msg)
            this.findTableData()
            this.dialogVisible = false
          }
        }
      })
    },
    async searchTableData() {
      if (this.environment === 'SAAS') {
        await this.findSourceData() // 获取下拉框数据
      }
      this.page.pageNo = 1
      this.findTableData()
    },
    async findTableData() {
      this.tableLoading = true
      let reqData = null
      if (this.environment === 'DIY') {
        reqData = _.assign({
          skipCount: (this.page.pageNo - 1) * this.page.pageSize,
          maxResultCount: this.page.pageSize,
          dataCategoryId: this.dicTypeId,
          name: this.queryForm.name,
          code: this.queryForm.code,
        })
      } else {
        reqData = _.assign({
          pageno: this.page.pageNo,
          pagesize: this.page.pageSize,
          owner_id: '',
          dic_cate_id: this.dicTypeId,
          name: {
            $text: this.queryForm.name,
          },
          code: {
            $text: this.queryForm.code,
          },
        })
      }
      const res = await CommonService.list({
        reqUrl: this.currentService,
        reqData,
      })
      this.tableLoading = false
      if (res && res.code === 0) {
        if (this.environment === 'DIY') {
          this.page.recordCount = res.totalCount
        } else {
          this.page.recordCount = res.page.recordCount
        }
        this.tableData = res.data
        _.forEach(this.tableData, (item) => {
          if (_.find(this.totalSelection, ['id', item.id])) {
            this.$nextTick(() => {
              this.$refs.multipleTable.toggleRowSelection(item, true)
            })
          }
        })
        this.$nextTick(() => {
          if (this.$refs.multipleTable) {
            this.$refs.multipleTable.doLayout()
          }
        })
      }
    },
    async findDetail(id) {
      const res = await CommonService.list({
        reqUrl: this.currentService,
        reqData: {
          id,
        },
      })
      if (res && res.code === 0 && res.data) {
        this.handleData = _.cloneDeep(res.data)
        this.formData = _.filter(this.listTypes, (item) => {
          return item.formShow === 1
        })
        _.forEach(this.formData, (item) => {
          item.value = res.data[item.bindDataName]
          item[item.bindDataName] = res.data[item.bindDataName]
        })
        this.dialogVisible = true
      }
    },
    handleEvent(type, data) {
      this.handleType = type
      this.handleId = data ? data.id : ''
      if (type !== 'delete') {
        _.forEach(this.tableHeader, (item) => {
          item.value = type === 'create' ? '' : data[item.prop]
        })
      }
      switch (type) {
        case 'create':
          this.dialogTitle = `${this.$t('create')}-${this.$t('dictItem')}`
          this.handleId = ''
          this.formData = _.filter(this.listTypes, (item) => {
            item[item.bindDataName] = ''
            return item.formShow === 1
          })
          this.form = this.$options.data().form
          // 新增时选中左边的字典类型，类型名称默认为当前选中项的名称
          if (this.dicTypeId !== '') {
            _.map(this.formData, (item) => {
              if (item.bindDataName === 'dicCateId') {
                item.dicCateId = this.dicTypeId
              }
              return item
            })
            if (this.environment === 'DIY') {
              this.form.dataCategoryId = this.dicTypeId
            } else {
              this.form.dicCateId = this.dicTypeId
            }
          }
          this.dialogVisible = true
          this.$nextTick(() => {
            this.$refs.form.clearValidate()
          })
          break
        case 'read':
          this.dialogTitle = `${this.$t('view')}-${this.$t('dictItem')}`
          this.form = _.cloneDeep(data)
          this.dialogVisible = true
          this.$nextTick(() => {
            this.$refs.form.clearValidate()
          })
          // this.findDetail(data.id)
          break
        case 'edit':
          this.dialogTitle = `${this.$t('edit')}-${this.$t('dictItem')}`
          this.form = _.cloneDeep(data)
          this.dialogVisible = true
          this.$nextTick(() => {
            this.$refs.form.clearValidate()
          })
          // this.findDetail(data.id)
          break
        case 'delete':
          this.$confirm(`${this.$t('deleteRecord')}?`, this.$t('tip'), {
            confirmButtonText: this.$t('confirm'),
            cancelButtonText: this.$t('cancel'),
            type: 'warning',
          })
            .then(async () => {
              const res = await CommonService.remove({
                reqUrl:
                  this.environment === 'DIY' ? `${this.currentService}/many` : this.currentService,
                reqData: {
                  data: [data.id],
                },
              })
              if (res && res.code === 0) {
                this.$message.success(res.msg)
                if (this.tableData.length === 1 && this.page.pageNo > 1) {
                  this.pageNo -= 1
                }
                this.findTableData()
              }
            })
            .catch(() => {})
          break
        default:
          console.log('no default type')
      }
    },
  },
}
</script>
